// Static demo — no backend API
export const getApiBase = (): string => ''
